import React, { Component } from 'react';

class RegionsList extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { selectedRegion, handleTileClick, regions, ...rest } = this.props;
        const props = {};
        props.className = 'regions-list';

        return (
            <ul {...props} {...rest}>
                {regions.map(region => {
                    let itemProps = {};
            
                    itemProps.className = 'regions-list__item';
                    if (selectedRegion == region.term_id) {
                        itemProps.className += ' regions-list__item--selected';
                    }

                    return (
                        <li {...itemProps} key={region.term_id} onClick={() => {
                            handleTileClick(region)
                        }}>
                            <span>{region.name}</span>
                        </li>
                    )
                 })}
            </ul>
        );
    }
}

export { RegionsList };